"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/EGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_67)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_67`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.45966 14.3439C9.45966 14.3439 9.45966 10.2456 9.77545 9.80351C9.99299 9.50176 10.9544 10.1684 11.3684 10.1193C11.3684 10.1193 11.6632 9.59298 11.6842 9.27719C11.7053 8.95439 11.607 8.74386 11.3404 8.84211C11.3404 8.84211 11.2561 8.69474 11.3754 8.61053C11.4877 8.52632 11.7684 8.61755 11.7684 8.61755C11.7684 8.61755 11.7333 8.54737 11.8807 8.55439C12.0842 8.56842 12.386 8.65263 12.4 8.94737C12.414 9.16491 12.4211 9.48772 12.4281 9.5579C12.4772 10.0351 12.6175 10.1684 12.6175 10.1684C12.6175 10.1684 13.9088 9.52281 14.1614 9.80351C14.393 10.0702 14.4772 14.3439 14.4772 14.3439L13.207 13.1649L14.0561 15.2351C14.0561 15.2351 13.0456 15.4035 12.0281 15.4035C11.0105 15.4035 9.84562 15.1088 9.84562 15.1088L10.814 13.1298L9.45966 14.3439Z",
					fill: "#C09300"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_67`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as EGFlag };
